export const ROLES = {
  ADMIN: 'ADMIN',
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  MANAGER: 'MANAGER',
  SUPERVISOR: 'SUPERVISOR',
  DEVELOPER: 'DEVELOPER',
}
